import React from 'react';
import { motion } from 'framer-motion';

const OnboardingStepWelcome = ({ onNext }) => {
  return (
    <div className="text-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.8 }}
      >
        <p className="text-[13px] tracking-[0.2em] uppercase text-[#f97316] mb-6 font-medium">
          Let's get started
        </p>

        <h1 className="text-[2.5rem] sm:text-[3.25rem] font-light tracking-tight leading-[1.1] text-gray-900 mb-5">
          Welcome to<br />
          <span className="text-[#f97316]">Klorah</span>
        </h1>

        <p className="text-[15px] sm:text-base text-gray-400 leading-relaxed max-w-sm mx-auto mb-12">
          Set up your business profile in a few quick steps. It only takes a minute.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <button
          onClick={onNext}
          className="w-full py-4 bg-[#f97316] hover:bg-[#ea580c] text-white text-[15px] font-medium rounded-xl transition-colors"
        >
          Continue
        </button>
      </motion.div>
    </div>
  );
};

export default OnboardingStepWelcome;
